import {spotheroGet} from 'api';
import {sendSentryException} from 'utils/error-handling';
import {camelizeKeys} from 'utils/format-strings';
import {
    ReservationDailyCountResponse,
    ReservationsDailyCount,
} from './reservations.types';

export const formatGetReservationsDailyCountResponse = (
    data: ReservationDailyCountResponse
) => {
    const formattedData: ReservationsDailyCount = camelizeKeys(data);

    return formattedData;
};

const getReservationsDailyCount = async (facilityId: number) => {
    try {
        const response = await spotheroGet<ReservationDailyCountResponse>(
            `operator-reservations/facilities/${facilityId}/daily/counts/`
        );

        const formattedResponse = formatGetReservationsDailyCountResponse(
            response.data.data
        );

        return formattedResponse;
    } catch (error) {
        sendSentryException(error);

        throw new Error(error.message);
    }
};

export default getReservationsDailyCount;
